// Fragment "shared client auth" — the Google + email-OTP sign-in UI gating every
// transactional action on a tenant public site (components/auth/ClientAuthPanel.jsx,
// ClientAuthDialog.jsx, useRequireAuth.js). See
// docs/auth-and-admin/client-otp-auth-contract.md for the endpoint contract, the
// error-code → key mapping, and the full key list this fragment must carry. Merged
// in ./index.js.
export default {
  fr: {
    "clientAuth.title": "Connectez-vous pour continuer",
    "clientAuth.subtitle": "Une connexion rapide suffit pour réserver, acheter ou vous inscrire.",
    "clientAuth.emailLabel": "Adresse e-mail",
    "clientAuth.emailPh": "vous@exemple.com",
    "clientAuth.emailInvalid": "Entrez une adresse e-mail valide.",
    "clientAuth.sendCode": "Recevoir un code",
    "clientAuth.codeSentTo": "Un code a été envoyé à {email}",
    "clientAuth.codeLabel": "Code à 6 chiffres",
    "clientAuth.verify": "Valider",
    "clientAuth.resend": "Renvoyer le code",
    "clientAuth.resendIn": "Renvoyer dans {s} s",
    "clientAuth.changeEmail": "Utiliser une autre adresse e-mail",
    "clientAuth.or": "ou",
    "clientAuth.google": "Continuer avec Google",
    "clientAuth.signedInAs": "Connecté en tant que {email}",
    "clientAuth.dismissed": "Une connexion est nécessaire pour finaliser cet achat. Rien n'a été facturé.",
    "clientAuth.emailReplaced": "Cet achat sera enregistré au nom de {email}, l'adresse avec laquelle vous venez de vous connecter. Vérifiez les détails puis confirmez à nouveau pour continuer.",
    "clientAuth.notYou": "Pas vous ?",
    "clientAuth.cancel": "Annuler",
    "clientAuth.marketingConsent": "Envoyez-moi par e-mail les nouvelles et les offres de {practice} (facultatif)",
    "clientAuth.practiceFallback": "ce cabinet",
    "clientAuth.termsAccept": "J'accepte les {terms} et la {privacy}",
    "clientAuth.termsLink": "conditions d'utilisation",
    "clientAuth.privacyLink": "politique de confidentialité",
    "clientAuth.errTermsRequired": "Acceptez les conditions d'utilisation et la politique de confidentialité pour continuer.",
    "clientAuth.errInvalid": "Ce code est incorrect ou a déjà été utilisé.",
    "clientAuth.errExpired": "Ce code a expiré. Demandez-en un nouveau.",
    "clientAuth.errTooMany": "Trop de tentatives incorrectes. Demandez un nouveau code.",
    "clientAuth.errCooldown": "Un code a déjà été envoyé récemment. Vérifiez votre boîte de réception ou patientez avant d'en redemander un.",
    "clientAuth.errRateLimited": "Trop de tentatives. Merci de patienter un instant avant de réessayer.",
    "clientAuth.errDeliveryFailed": "Nous n'avons pas pu envoyer le code à cette adresse. Vérifiez-la, puis réessayez.",
    "clientAuth.errPrivileged": "Cette adresse est un compte d'administration Solunary. Les comptes privilégiés se connectent avec Google — utilisez le bouton Google ci-dessus, ou une autre adresse pour vos achats.",
    "clientAuth.errGeneric": "Une erreur est survenue. Merci de réessayer.",
  },
  en: {
    "clientAuth.title": "Sign in to continue",
    "clientAuth.subtitle": "A quick sign-in is all it takes to book, buy, or enrol.",
    "clientAuth.emailLabel": "Email address",
    "clientAuth.emailPh": "you@example.com",
    "clientAuth.emailInvalid": "Enter a valid email address.",
    "clientAuth.sendCode": "Send me a code",
    "clientAuth.codeSentTo": "A code was sent to {email}",
    "clientAuth.codeLabel": "6-digit code",
    "clientAuth.verify": "Verify",
    "clientAuth.resend": "Resend code",
    "clientAuth.resendIn": "Resend in {s}s",
    "clientAuth.changeEmail": "Use a different email",
    "clientAuth.or": "or",
    "clientAuth.google": "Continue with Google",
    "clientAuth.signedInAs": "Signed in as {email}",
    "clientAuth.dismissed": "Signing in is required to complete this purchase. Nothing was charged.",
    "clientAuth.emailReplaced": "This purchase will be recorded under {email}, the address you just signed in with. Check the details, then confirm again to continue.",
    "clientAuth.notYou": "Not you?",
    "clientAuth.cancel": "Cancel",
    "clientAuth.marketingConsent": "Send me news and offers from {practice} by email (optional)",
    "clientAuth.practiceFallback": "this practice",
    "clientAuth.termsAccept": "I accept the {terms} and the {privacy}",
    "clientAuth.termsLink": "terms of use",
    "clientAuth.privacyLink": "privacy policy",
    "clientAuth.errTermsRequired": "Accept the terms of use and the privacy policy to continue.",
    "clientAuth.errInvalid": "That code is incorrect or has already been used.",
    "clientAuth.errExpired": "That code has expired. Request a new one.",
    "clientAuth.errTooMany": "Too many incorrect attempts. Request a new code.",
    "clientAuth.errCooldown": "A code was already sent recently. Check your inbox or wait a moment before requesting another.",
    "clientAuth.errRateLimited": "Too many attempts. Please wait a moment and try again.",
    "clientAuth.errDeliveryFailed": "We could not send the code to that address. Check it and try again.",
    "clientAuth.errPrivileged": "That address is a Solunary administration account. Privileged accounts sign in with Google — use the Google button above, or a different address for your own purchases.",
    "clientAuth.errGeneric": "Something went wrong. Please try again.",
  },
  es: {
    "clientAuth.title": "Inicie sesión para continuar",
    "clientAuth.subtitle": "Basta con iniciar sesión rápidamente para reservar, comprar o inscribirse.",
    "clientAuth.emailLabel": "Correo electrónico",
    "clientAuth.emailPh": "usted@ejemplo.com",
    "clientAuth.emailInvalid": "Introduce una dirección de correo electrónico válida.",
    "clientAuth.sendCode": "Enviarme un código",
    "clientAuth.codeSentTo": "Se envió un código a {email}",
    "clientAuth.codeLabel": "Código de 6 dígitos",
    "clientAuth.verify": "Verificar",
    "clientAuth.resend": "Reenviar código",
    "clientAuth.resendIn": "Reenviar en {s} s",
    "clientAuth.changeEmail": "Usar otro correo electrónico",
    "clientAuth.or": "o",
    "clientAuth.google": "Continuar con Google",
    "clientAuth.signedInAs": "Sesión iniciada como {email}",
    "clientAuth.dismissed": "Es necesario iniciar sesión para completar esta compra. No se ha cobrado nada.",
    "clientAuth.emailReplaced": "Esta compra se registrará a nombre de {email}, la dirección con la que acabas de iniciar sesión. Revisa los detalles y confirma de nuevo para continuar.",
    "clientAuth.notYou": "¿No es usted?",
    "clientAuth.cancel": "Cancelar",
    "clientAuth.marketingConsent": "Envíenme por correo electrónico las novedades y ofertas de {practice} (opcional)",
    "clientAuth.practiceFallback": "esta consulta",
    "clientAuth.termsAccept": "Acepto las {terms} y la {privacy}",
    "clientAuth.termsLink": "condiciones de uso",
    "clientAuth.privacyLink": "política de privacidad",
    "clientAuth.errTermsRequired": "Acepta las condiciones de uso y la política de privacidad para continuar.",
    "clientAuth.errInvalid": "Ese código es incorrecto o ya se ha utilizado.",
    "clientAuth.errExpired": "Ese código ha caducado. Solicite uno nuevo.",
    "clientAuth.errTooMany": "Demasiados intentos incorrectos. Solicite un nuevo código.",
    "clientAuth.errCooldown": "Ya se envió un código recientemente. Revise su bandeja de entrada o espere un momento antes de solicitar otro.",
    "clientAuth.errRateLimited": "Demasiados intentos. Espere un momento antes de volver a intentarlo.",
    "clientAuth.errDeliveryFailed": "No pudimos enviar el código a esa dirección. Compruébela e inténtelo de nuevo.",
    "clientAuth.errPrivileged": "Esa dirección es una cuenta de administración de Solunary. Las cuentas privilegiadas inician sesión con Google — use el botón de Google de arriba, o otra dirección para sus propias compras.",
    "clientAuth.errGeneric": "Ocurrió un error. Inténtelo de nuevo.",
  },
};
